// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabAttachedRequests-moduleRequestProfileTabAttachedRequests__Zz5Ex";
export { _1 as "RequestProfileTabAttachedRequests" }
